import Button from 'app/components/Button'
import {useState} from 'react'
import ConnectCloudModal from '../modal/ConnectCloudModal'

const CloudListToolbar = () => {
  const [showConnectModal, setShowConnectModal] = useState(false)

  const openConnectCloudModal = () => {
    setShowConnectModal(true)
  }

  const closeConnectCloudModal = () => {
    setShowConnectModal(false)
  }

  return (
    <>
      <div className='d-flex justify-content-end' data-kt-user-table-toolbar='base'>
        <Button btnType='primary' onClick={openConnectCloudModal}>
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='18'
            height='18'
            viewBox='0 0 24 24'
            fill='none'
            stroke='currentColor'
            strokeWidth='2'
            strokeLinecap='round'
            strokeLinejoin='round'
            className='icon icon-tabler icons-tabler-outline icon-tabler-plus me-2'
          >
            <path stroke='none' d='M0 0h24v24H0z' fill='none' />
            <path d='M12 5l0 14' />
            <path d='M5 12l14 0' />
          </svg>
          Connect Cloud
        </Button>
      </div>

      <ConnectCloudModal show={showConnectModal} onClose={closeConnectCloudModal} />
    </>
  )
}

export {CloudListToolbar}
